module.exports = __webpack_public_path__ + "assets/config/en-US.json";